import { useMemo } from 'react';

import { convertMaxWin, formatLootboxItemTitle } from '../helpers/fortuneWheel';
import { BonusAttributeField, LootboxBonus } from '@/api/common';
import { useCommonStore } from '@/store';

export const useLootboxBonus = (bonus: LootboxBonus | null) => {
  const currencies = useCommonStore.use.currencies();

  const wager = useMemo(() => {
    if (bonus?.type === 'freespins') {
      return bonus?.resultBonus!.find(
        (item) => item.field === BonusAttributeField.Wager
      )!.value;
    }

    return bonus?.attributes!.find(
      (item) => item.field === BonusAttributeField.Wager
    )!.value;
  }, [bonus]);

  const bonusAmount = useMemo(() => {
    if (bonus?.type === 'freespins') return null;

    const value = bonus?.attributes!.find(
      (item) => item.field === BonusAttributeField.BonusAmount
    )!.value;

    if (typeof value === 'number' || !value) return null;

    return convertMaxWin(value, currencies);
  }, [bonus, currencies]);

  const maxWin = useMemo(() => {
    const value = bonus?.resultBonus!.find(
      (item) => item.field === BonusAttributeField.MaxWin
    )!.value;

    if (typeof value === 'number' || !value) return null;

    return convertMaxWin(value, currencies);
  }, [bonus, currencies]);

  const title = useMemo(
    () => formatLootboxItemTitle(bonus?.title ?? ''),
    [bonus?.title]
  );

  return { wager, bonusAmount, maxWin, title };
};
